import { FC, ReactNode } from 'react';
import { AText } from '../AText';

import styles from './index.module.css';

interface LabelProps {
  children: ReactNode;
  htmlFor?: string;
  className?: string;
}

export const Label: FC<LabelProps> = ({
  className = '',
  htmlFor,
  children,
  ...props
}) => (
  <AText
    component="label"
    breed="R"
    size="m"
    htmlFor={htmlFor}
    className={`${styles.label} ${className}`}
    {...props}
  >
    {children}
  </AText>
);
